import theme from './theme';
import round from '../helpers/round';
import range from '../helpers/range';

export const containerStyle = {
  marginTop: theme.padding.gutter / 2,
};

const minWidth = 308;
const tileGutter = theme.padding.gutter;
export const tileStyle = columns => ({
  flex: '0 0 auto',
  margin: tileGutter / 2,
  width: '60%',
  minWidth,
  ...range(columns - 1).reduce((breakpoints, i) => {
    const column = i + 2;
    const containerWidth = minWidth * (column + 0.1) // to fit n tiles, plus 0.1x of the (n+1)th
      + tileGutter * column;
    return {
      ...breakpoints,
      [theme.breakpoints.up(round(containerWidth + theme.padding.horizontal * 2))]: {
        width: `${round(100 * minWidth / containerWidth)}%`,
      },
    };
  }, {}),
});

export default (tileName, tilesName, columns) => ({
  [tilesName]: containerStyle,
  [tileName]: tileStyle(columns),
});
